import { FC, useEffect } from "react";
import { useIntl } from "react-intl";
import { Toggle } from "rsuite";
import { useSettingsStore } from "../../stores/SettingsStore";

interface TableAddLogProductsProps {
    formik: any
}

export const TableToggleProgress: FC<TableAddLogProductsProps> = ({ formik }) => {
    const intl = useIntl()
    const { settings } = useSettingsStore()

    const rows = [
    {
        labelId: 'PROGRESS.TABLE.ADD.PRODUCT',
        fields: ['editLeadProductAccess.create', null],
    },
    {
        labelId: 'PROGRESS.TABLE.DELETE.PRODUCT',
        fields: ['editLeadProductAccess.delete', null],
    },
    {
        labelId: 'PROGRESS.TABLE.UPDATE.QTY',
        fields: ['editLeadProductAccess.edit.quantity', null],
    },
    {
        labelId: 'PROGRESS.TABLE.UPDATE.DISCOUNT',
        fields: ['editLeadProductAccess.edit.discount', null],
    },
    {
        labelId: 'PROGRESS.TABLE.UPDATE.PRICE',
        fields: ['editLeadProductAccess.edit.price', null],
    },
    {
        labelId: 'PROGRESS.TABLE.UPDATE.COGS',
        fields: ['editLeadProductAccess.edit.cogs', settings.update_log_hpp_progress ? 'update_log_hpp_progress' : null],
    },
    {
        labelId: 'FORM.LABEL.ATTACHMENT',
        fields: [null, 'isRequiredAttachment'],
    },
    ...(formik.values.progressType === "SUCCESS" ? [{
        labelId: 'FORM.LABEL.SPLITTABLE_TERMIN',
        fields: [null, 'isSplittable'],
    }]:[]),
    ];

    const columnIds = [
        'MASTERS.DATATABLE.COLUMNS.NAME',
        // 'MASTERS.DATATABLE.COLUMNS.ADD',
        // 'MASTERS.DATATABLE.COLUMNS.UPDATE',
        // 'MASTERS.DATATABLE.COLUMNS.DELETE',
        'MASTERS.DATATABLE.COLUMNS.ACCESSS',
        'MASTERS.DATATABLE.COLUMNS.REQUIRED',
    ];

    function getNestedValue(obj: any, path: string): any {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    useEffect(() => {
        if (formik.values.update_log_hpp_progress === true) {
            formik.setFieldValue('editLeadProductAccess.edit.cogs', true);
        }
    }, [formik.values]);


    return (
        <table className="table table-striped gs-7">
            <thead>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                {columnIds.map((id, index) => (
                    <th key={index} className="xl:min-w-100px">
                        {intl.formatMessage({ id })}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
                {rows.map((row, idx) => (
                    <tr key={idx}>
                    <td>{intl.formatMessage({ id: row.labelId })}</td>
                        {row.fields.map((field, i) => (
                            <td key={i}>
                                {field ? (
                                    <Toggle
                                        className="col-md-5 col-lg-3 col-xl-3"
                                        {...formik.getFieldProps(field)}
                                        // checked={formik.values[field]!}
                                        checked={getNestedValue(formik.values, field) ?? false}
                                        onChange={(e) => formik.setFieldValue(field, e)}
                                    />
                                ) : (
                                    '-'
                                )}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};